import React from 'react';
import AuthLoginPage from '../../components/Auth/AuthLoginPage';

const AdminLogin = () => (
    <AuthLoginPage
        title="Connexion Admin"
        subtitle="Connectez-vous à l'interface d'administration"
        redirectPath="/dashboard/operations"
        mfaPath="/admin/mfa"
        resetPasswordPath="/admin/reset-password"
    />
);

export default AdminLogin;
